import React, { Component } from 'react'
import { PanelGroup, Panel } from 'react-bootstrap'

class HostingerFAQs extends Component{
	constructor(props){
		super(props)
		this.state = {}
		this.handleFAQSelect = this.handleFAQSelect.bind(this)
	}
	
	handleFAQSelect(activeFAQKey) {
		let _key = this.state.activeFAQKey
		if (_key && _key == activeFAQKey) {
			this.setState({ activeFAQKey: false })
		} else {
			this.setState({ activeFAQKey: activeFAQKey })
		}
	}
	
	render(){
		const { activeFAQKey } = this.state
		return (
			<div>
				<PanelGroup 
					activeKey={activeFAQKey}
					onSelect={this.handleFAQSelect}
					bsClass="col-xs-10 col-md-10 bv-faq-accordion-list"
					id="hostinger"
					accordion
				>

				<Panel eventKey="1">
					<Panel.Heading bsClass="panel-heading">
						<Panel.Title toggle>
							<p className="bv-faq-que">
								{ activeFAQKey == "1" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
								What is Destination Site URL?
							</p>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible>
						<p className="bv-faq-ans">
							Destination Site URL of the site you are moving to.
						</p>
					</Panel.Body>
				</Panel>

				<Panel eventKey="2">
					<Panel.Heading bsClass="panel-heading">
						<Panel.Title toggle>
							<p className="bv-faq-que">
								{ activeFAQKey == "2" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
								Where can I find the Site Server IP Address?
							</p>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible>
						<p className="bv-faq-ans">
							For your site server IP address, log in to your Domain account on Hostinger, click on <strong>Account details</strong> and go to <strong>FTP Upload details</strong>.
						</p>
					</Panel.Body>
				</Panel>

			</PanelGroup>
			</div>
		)	
	}
}

export default HostingerFAQs
